import { useLocation } from '@react-router';
import { useTranslation } from '@shared/core';
import { useEventNameMatch } from '@shared/components/AuthProvider/AuthProvider.utils';
import { withWindow } from '@shared/utils/withWindow';
import type { SuccessFormProps } from './FindInviteSuccessForm';

export const useFindInviteSuccessController = ({ guest }: SuccessFormProps) => {
  const location = useLocation();
  const { eventName } = useEventNameMatch();
  const { t, t2 } = useTranslation('guestUnlock');
  const title = t('findInviteSuccessForm', 'title')({ firstName: guest.firstName });
  const { subtitle, submitButtonText } = t2('findInviteSuccessForm');

  const onSubmitHandler = () => {
    // Full-page navigation to /schedule with a single browser nav. We avoid
    // calling onDialogClose() (which now triggers a reload via the provider's
    // close wrapper) followed by history.push() — two competing navigations
    // would race, and the reload could land the guest on the current URL
    // instead of /schedule.
    withWindow(global => global.location.assign(`/${eventName}/schedule${location.search}`));
  };

  return {
    title,
    subtitle,
    submitButtonText,
    onSubmitHandler,
  };
};
